import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import Layout from "../components/Layout";
import CookieImage from "../components/CookieImage";
import { api, errorMessage } from "../lib/api";

export default function FlavorsPage() {
  const [flavors, setFlavors] = useState([]);
  const [open, setOpen] = useState(false);
  const [flavorName, setFlavorName] = useState("");
  const [notes, setNotes] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => { api.get("/flavors").then(r => setFlavors(r.data)).catch(() => {}); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!flavorName.trim()) return;
    setSubmitting(true);
    try {
      await api.post("/flavor-requests", { flavor_name: flavorName, notes });
      toast.success("Flavor request sent!");
      setFlavorName(""); setNotes(""); setOpen(false);
    } catch (e) { toast.error(errorMessage(e)); }
    finally { setSubmitting(false); }
  };

  return (
    <Layout>
      <section className="page-section" data-testid="flavors-page">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-12">
            <p className="text-sm uppercase tracking-[0.25em] font-bold text-white/85 drop-shadow">Rotating Weekly</p>
            <h1 className="font-display font-extrabold text-4xl md:text-6xl mt-2 text-white drop-shadow-lg">This Week's Flavors</h1>
            <p className="text-white/90 max-w-xl mx-auto mt-4">Each cookie is approximately 4 oz and 4 inches large. Brand new gourmet flavors drop every week.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {flavors.map((f) => (
              <div key={f.id} className="card-soft p-6 md:p-8 flex flex-col md:flex-row items-center gap-6" data-testid={`flavor-card-${f.image_key}`}>
                <CookieImage flavorKey={f.image_key} imageUrl={f.image_url} className="w-40 h-40 md:w-52 md:h-52 rounded-full shadow-lg flex-shrink-0" />
                <div className="flex-1">
                  <h3 className="font-display font-extrabold text-2xl md:text-3xl">{f.name}</h3>
                  <p className="text-[#4B5563] mt-2 leading-relaxed">{f.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <button className="btn-white" onClick={() => setOpen(true)} data-testid="request-flavor-btn">REQUEST A FLAVOR</button>
          </div>
        </div>
      </section>

      {open && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-end md:items-center justify-center p-0 md:p-4" data-testid="flavor-request-modal" onClick={() => setOpen(false)}>
          <div className="bg-white rounded-t-3xl md:rounded-3xl p-6 md:p-8 w-full max-w-md fade-in" onClick={(e) => e.stopPropagation()}>
            <h3 className="font-display font-extrabold text-2xl mb-4">Request A Flavor</h3>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="text-sm font-bold uppercase tracking-wider text-[#4B5563]">Flavor Name</label>
                <input className="input-base mt-1" value={flavorName} onChange={(e) => setFlavorName(e.target.value)} placeholder="e.g. Lemon Lavender" required data-testid="flavor-request-name" />
              </div>
              <div>
                <label className="text-sm font-bold uppercase tracking-wider text-[#4B5563]">Notes</label>
                <textarea className="input-base mt-1 min-h-[100px]" value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Anything else?" data-testid="flavor-request-notes" />
              </div>
              <div className="flex gap-3 justify-end">
                <button type="button" onClick={() => setOpen(false)} className="btn-outline-pink !py-2 !px-5">CANCEL</button>
                <button type="submit" disabled={submitting} className="btn-pink !py-2 !px-5" data-testid="flavor-request-submit">{submitting ? "SENDING..." : "SUBMIT"}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </Layout>
  );
}
